import { faCheck } from "@fortawesome/pro-duotone-svg-icons";
import { signal } from "@preact/signals-react";
import { InputSeparator, InputSuffix, TextBox } from "@progress/kendo-react-inputs";
import { Menu, MenuItem } from "@progress/kendo-react-layout";
import { Popup } from "@progress/kendo-react-popup";
import { TreeView } from "@progress/kendo-react-treeview";
import { useEffect } from "react";
import { ColorChangingIcon } from "../../Common/UI/ColorChangingIcon";
import { Else, If } from "../../Common/UI/IfComponent";
import {
  automationSessionData,
  automationTreeViewItems,
  selectedAutomationTreeViewItem,
} from "../NewTemplateSignals";

const showContextMenu = signal(false);
const contextMenuPosition = signal({ left: 0, top: 0 });
const clickedTreeViewItem = signal(null);
const isEdit = signal(false);
const newAutomationName = signal("");

const Suffix = () => {
  return (
    <>
      <InputSeparator
        style={{
          width: "1px",
          backgroundColor: "gainsboro",
          margin: "4px 0px",
        }}
      />
      <InputSuffix>
        <ColorChangingIcon
          icon={faCheck}
          initialPrimaryColor="#0078D4"
          initialSecondaryColor="#605e5c"
          margin="1px 5px 0 5px"
          onClick={(e) => {
            e.stopPropagation();
            isEdit.value = false;
            const newAutomationSessionData = [...automationSessionData.value];
            const automationIndex = newAutomationSessionData.findIndex(
              (automation) => automation.id === clickedTreeViewItem.value
            );
            const newAutomation = automationSessionData.value[automationIndex];
            newAutomation.name = newAutomationName.value;
            newAutomationSessionData[automationIndex] = newAutomation;
            automationSessionData.value = newAutomationSessionData;
            newAutomationName.value = "";
          }}
        />
      </InputSuffix>
    </>
  );
};

const AutomationItem = (props) => {
  return (
    <div>
      <If condition={isEdit.value && clickedTreeViewItem.value === props.item.id}>
        <TextBox
          defaultValue={props.item.text}
          onChange={(e) => {
            newAutomationName.value = e.target.value;
          }}
          onKeyDown={(e) => {
            if (e.key === " ") {
              e.stopPropagation();
            }
            if (e.key === "Enter") {
              isEdit.value = false;
              const newAutomationSessionData = [...automationSessionData.value];
              const automationIndex = newAutomationSessionData.findIndex(
                (automation) => automation.id === clickedTreeViewItem.value
              );
              const newAutomation = automationSessionData.value[automationIndex];
              newAutomation.name = newAutomationName.value;
              newAutomationSessionData[automationIndex] = newAutomation;
              automationSessionData.value = newAutomationSessionData;
              newAutomationName.value = "";
            }
          }}
          suffix={() => Suffix()}
        />
        <Else>
          <span>{props.item.text}</span>
        </Else>
      </If>
    </div>
  );
};

export const AutomationTreeView = () => {
  const handleContextMenu = (e) => {
    e.nativeEvent.preventDefault();
    isEdit.value = false;
    clickedTreeViewItem.value = e.item.id;
    showContextMenu.value = true;
    contextMenuPosition.value = { left: e.syntheticEvent.clientX, top: e.syntheticEvent.clientY };
  };

  const handleContextMenuClick = (e) => {
    if (e.item.text === "Rename Automation") {
      isEdit.value = true;
      newAutomationName.value = automationSessionData.value.find(
        (automation) => automation.id === clickedTreeViewItem.value
      ).name;
    }
  };

  useEffect(() => {
    document.addEventListener("click", () => {
      if (showContextMenu.value) {
        showContextMenu.value = false;
      }
    });
  }, []);

  return (
    <>
      <TreeView
        data={automationTreeViewItems.value}
        checkboxes={true}
        onItemClick={(event) => {
          selectedAutomationTreeViewItem.value = event.item.id;
        }}
        onCheckChange={(event) => {
          selectedAutomationTreeViewItem.value = event.item.id;
          isEdit.value = false;
        }}
        onContextMenu={(e) => {
          handleContextMenu(e);
        }}
        item={AutomationItem}
      />
      <Popup
        show={showContextMenu.value}
        offset={{ left: contextMenuPosition.value.left, top: contextMenuPosition.value.top }}
      >
        <Menu
          vertical={true}
          style={{ display: "inline-block" }}
          onSelect={(e) => {
            handleContextMenuClick(e);
          }}
        >
          <MenuItem text="Rename Automation"></MenuItem>
        </Menu>
      </Popup>
    </>
  );
};
